import requestFlow from '@/utils/requestFlow'
import { opportunityRoutine, seeMoreRoutine, OPPORTUNITY_CLEANUP, SEE_MORE_CLEANUP } from './routines'

export default {
  ...requestFlow(opportunityRoutine).mockMutations,

  [opportunityRoutine.SUCCESS](state, payload) {
    state.opportunityList = payload.opportunities
  },
  [seeMoreRoutine.SUCCESS](state, payload) {
    state.seeMore = payload
  },
  [OPPORTUNITY_CLEANUP](state, payload) {
    Object.assign(state, payload)
  },
  [SEE_MORE_CLEANUP](state, payload) {
    Object.assign(state, payload)
  }
}
